import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "notice-detail-box"
};
var _hoisted_2 = ["srcdoc"];
import { computed } from 'vue';
export default {
  __name: 'NoitceDetaill',
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var iframeDoc = computed(function () {
      return "\n    <!DOCTYPE html>\n    <html lang=\"en\">\n    <head>\n      <meta charset=\"UTF-8\">\n      <meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">\n      </head>\n      <style>\n        body {\n          font-family: 'Microsoft YaHei';\n          font-size: 14px;\n        }\n        ::-webkit-scrollbar {\n          width: 4px;\n        }\n        ::-webkit-scrollbar-track {\n          background: #ffffff;\n        }\n        ::-webkit-scrollbar-thumb {\n          background: #DCDDE1;\n        }\n        ::-webkit-scrollbar-thumb:hover {\n          background: #cccccc;\n        }\n      </style>\n    <body>\n      ".concat(props.content || '', "\n    </body>\n    </html>\n  ");
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("iframe", {
        class: "custom-scrollbar",
        srcdoc: iframeDoc.value,
        frameborder: "0"
      }, null, 8, _hoisted_2)]);
    };
  }
};